export default __webpack_public_path__ + "static/media/manager.89b5b2a8.pdf";